import { RouteConfig } from '@abaco/web-common/src/app';

const MODULE_BASE_PATH = "/buyer-contract";

const routes: RouteConfig[] = [
    {
        name: "buyer-contract-home",
        path: `${MODULE_BASE_PATH}/buyer-contract-home`,
        component: () => import("./components/BCSingleTileContainer.vue"),
        props: {tileId: "buyer-contract-list"},
    },
    {
        name: "bc-thresholds",
        path: `${MODULE_BASE_PATH}/bc-thresholds`,
        component: () => import("./components/BCSingleTileContainer.vue"),
        props: {tileId: "buyer-contract-thresholds"},
    },
    {
        name: "bc-subscribe",
        path: `/payment/bc-subscribe`,
        component: () => import("./components/PaymentContainer.vue"),
        meta: {expiredAllowed: true}
    }
];

export default routes;
